import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=0aa3611c&scoped=true"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"
import style0 from "./StudentList.vue?vue&type=style&index=0&id=0aa3611c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3611c",
  null
  
)

export default component.exports